import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import SplashScreen from './Fallback';

const App = lazy(() =>
  import("./App").catch((e) => {
    // console.error("Widget catch", e);
    return { default: () => <>Component unavailable please reload!</> };
  }),
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Suspense fallback={<SplashScreen />}>
    <App />
  </Suspense>
  // </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
